import React from "react";

import CoachPoolContext from "../../../contexts/CoachPoolContext";
import CoachPoolTeamsContext from "../../../contexts/CoachPoolTeamsContext";

import PageTitleNew from "../../ui/PageTitleNew";
import Table from "./Table";
import ModalForm from "./Create/Modal";

import ReactTooltip from "react-tooltip";

export default function Index() {
  return (
    <CoachPoolContext>
      <CoachPoolTeamsContext>
        <div className="wrapper_assestment invite_wrapper">
          <PageTitleNew title="Coach Pools" />

          <div className="ibox-content mt20">
            <Table />
          </div>
        </div>
        <ModalForm />
      </CoachPoolTeamsContext>
    </CoachPoolContext>
  );
}
